//#region src/schema/localization/locales/pt.ts
var e = {
	schema: {
		noAllowedValues: "Nenhum valor satisfaz esta restrição enum.",
		example: "Exemplo",
		examples: "Exemplos",
		default: "Padrão",
		schema: "Schema",
		emptyObject: "Objeto vazio",
		showAdditionalProperties: "Mostrar propriedades adicionais",
		showOneMoreProperty: "Mostrar mais 1 propriedade",
		showMoreProperties: "Mostrar mais {count} propriedades",
		forName: "para {name}",
		showSchemaDetails: "Mostrar Detalhes do Schema",
		oneOf: "Um de",
		anyOf: "Qualquer um de",
		allOf: "Todos de",
		not: "Não",
		unknownType: "tipo desconhecido",
		propertyCount: "Propriedades: {count}",
		headerCount: "Cabeçalhos: {count}",
		recursiveReference: "Referência recursiva a {name}",
		recursive: "recursivo",
		additionalProperties: "propriedades adicionais",
		const: "const",
		deprecated: "obsoleto",
		discriminator: "Discriminador",
		enum: "enum",
		format: "Formato",
		greaterThan: "maior que",
		keys: "chaves",
		lessThan: "menor que",
		max: "máx",
		min: "mín",
		maxLength: "tamanho máximo",
		minLength: "tamanho mínimo",
		multipleOf: "múltiplo de",
		nullable: "aceita nulo",
		propertyNames: "nomes de propriedades",
		pattern: "Padrão",
		copyPattern: "Copiar padrão",
		readOnly: "somente leitura",
		required: "obrigatório",
		hideValues: "Ocultar valores",
		showAllValues: "Mostrar todos os valores",
		type: "Tipo",
		unique: "único",
		values: "valores",
		writeOnly: "somente escrita"
	},
	common: {
		copyDefault: "Copiar valor padrão",
		copyExample: "Copiar valor de exemplo"
	},
	actions: { copyLinkTo: "Copiar link para {name}" }
};
//#endregion
export { e as pt };

//# sourceMappingURL=pt.js.map